// engine
import { ArController, gameDispatcher, helper } from '@aceroll/core';

// hacksaw
import { responseService } from '@aceroll/platform-hacksaw';

// platform
import { platform } from '../../platform';

export class Launch extends ArController {
	onStart() {
		platform.setLogger(helper);

		platform.onUiUpdateBetAmount((data) => {
			gameDispatcher.state.bet = data.bet.low;
		});

		platform.setGameReady().then((data) => {
			const { language } = data;

			responseService.updateInitServerData(data);

			gameDispatcher.state.localeCode = language;

			this.stop();
		});
	}
}
